/* eslint-disable prettier/prettier */
import { computed } from "vue"
import { useStore } from "vuex"

const user = () => {
    const store = useStore()

    const searchSegip = async(data) => {
        const resp = await store.dispatch("user/dataSegip", data)
        return resp
    }

    const nameDepartments = async() => {
        const resp = await store.dispatch("user/loadDepartments")
        return resp
    }

    const nameProvinces = async(department) => {
        const resp = await store.dispatch("user/loadProvinces", department)
        return resp
    }

    const namePenitentiaries = async() => {
        const resp = await store.dispatch("user/loadPenitentiaries")
        return resp
    }

    const namePenitentiary = async(data) => {
        const resp = await store.dispatch("user/loadPenitentiary", data)
        return resp
    }

    const nameRoles = async() => {
        const resp = await store.dispatch("user/loadRoles")
        return resp
    }

    const users = async() => {
        const resp = await store.dispatch("user/loadUsers")
        return resp
    }

    const createUser = async(data) => {
        // console.log('usePenitentiary', data)
        const resp = await store.dispatch("user/createUser", data)
        return resp
    }

    const infoUser = async(data) => {
        // console.log('usePenitentiary', data)
        const resp = await store.dispatch("user/infoUser", data)
        return resp
    }

    const infoRolesUser = async(data) => {
        // console.log('useUser infoRolesUser', data)
        const resp = await store.dispatch("user/loadRolesUser", data)
        return resp
    }

    const infoPasswordUser = async(data) => {
        const resp = await store.dispatch("user/loadPasswordUser", data)
        return resp
    }

    const updateUser = async(data) => {
        // console.log('usePenitentiary', data)
        const resp = await store.dispatch("user/updateUser", data)
        return resp
    }

    const updatePassword = async(data) => {
        const resp = await store.dispatch("user/updatePassword", data)
        return resp
    }

    const deleteUser = async(data) => {
        // console.log('usePenitentiary delete', data)
        const resp = await store.dispatch("user/deleteUser", data)
        return resp
    }

    const sendMail = async(data) => {
        // console.log('useUser sendMail')
        const resp = await store.dispatch("user/sendMail", data)
        return resp
    }

    const restoreCode = async(data) => {
        // console.log('useUser', data)
        const resp = await store.dispatch("user/restoreCode", data)
        return resp
    }

    const verifyCode = async(data) => {
        // console.log('useUser', data)
        const resp = await store.dispatch("user/verifyCode", data)
        return resp
    }

    const userRoles = async() => {
        const resp = await store.dispatch("user/userRoles")
        return resp
    }

    return {
        searchSegip,
        nameDepartments,
        nameProvinces,
        namePenitentiaries,
        namePenitentiary,
        nameRoles,
        users,
        createUser,
        infoUser,
        infoRolesUser,
        infoPasswordUser,
        updateUser,
        updatePassword,
        deleteUser,
        sendMail,
        restoreCode,
        verifyCode,

        userRoles,
    }
};

export default user